"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequisitionPgxReasonForTestingResponseToJSON = exports.RequisitionPgxReasonForTestingResponseFromJSONTyped = exports.RequisitionPgxReasonForTestingResponseFromJSON = exports.instanceOfRequisitionPgxReasonForTestingResponse = exports.RequisitionPgxReasonForTestingResponsePrimaryReasonEnum = exports.RequisitionPgxReasonForTestingResponseKidneyOrLiverProblemEnum = exports.RequisitionPgxReasonForTestingResponseMedicalRecordsEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.RequisitionPgxReasonForTestingResponseMedicalRecordsEnum = {
    AttachedInFiles: 'Attached in files',
    Empty: ''
};
/**
 * @export
 */
exports.RequisitionPgxReasonForTestingResponseKidneyOrLiverProblemEnum = {
    KidneyStone: 'kidney_stone',
    KidneyDialysis: 'kidney_dialysis',
    LiverCirrhosis: 'liver_cirrhosis',
    RecentKidneyInfection: 'recent_kidney_infection',
    RecentKidneyFailure: 'recent_kidney_failure',
    Eclampsia: 'eclampsia',
    LupusNephritis: 'lupus_nephritis',
    HivInfection: 'HIV_infection',
    PolycysticKidneys: 'polycystic_kidneys'
};
/**
 * @export
 */
exports.RequisitionPgxReasonForTestingResponsePrimaryReasonEnum = {
    AdverseDrugReaction: 'adverse_drug_reaction',
    IneffectiveMedication: 'ineffective_medication',
    InterestedInDna: 'interested_in_dna',
    InterestedInGenesMedication: 'interested_in_genes_medication',
    ProviderRecommended: 'provider_recommended'
};
/**
 * Check if a given object implements the RequisitionPgxReasonForTestingResponse interface.
 */
function instanceOfRequisitionPgxReasonForTestingResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfRequisitionPgxReasonForTestingResponse = instanceOfRequisitionPgxReasonForTestingResponse;
function RequisitionPgxReasonForTestingResponseFromJSON(json) {
    return RequisitionPgxReasonForTestingResponseFromJSONTyped(json, false);
}
exports.RequisitionPgxReasonForTestingResponseFromJSON = RequisitionPgxReasonForTestingResponseFromJSON;
function RequisitionPgxReasonForTestingResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'medicationsUnderEvaluation': !(0, runtime_1.exists)(json, 'medications_under_evaluation') ? undefined : json['medications_under_evaluation'],
        'completeMedicationList': !(0, runtime_1.exists)(json, 'complete_medication_list') ? undefined : json['complete_medication_list'],
        'medicalRecords': !(0, runtime_1.exists)(json, 'medical_records') ? undefined : json['medical_records'],
        'isKidneyOrLiverProblem': !(0, runtime_1.exists)(json, 'is_kidney_or_liver_problem') ? undefined : json['is_kidney_or_liver_problem'],
        'kidneyOrLiverProblem': !(0, runtime_1.exists)(json, 'kidney_or_liver_problem') ? undefined : json['kidney_or_liver_problem'],
        'otherKidneyOrLiverProblem': !(0, runtime_1.exists)(json, 'other_kidney_or_liver_problem') ? undefined : json['other_kidney_or_liver_problem'],
        'primaryReason': !(0, runtime_1.exists)(json, 'primary_reason') ? undefined : json['primary_reason'],
        'recentBloodTransfusion': !(0, runtime_1.exists)(json, 'recent_blood_transfusion') ? undefined : json['recent_blood_transfusion'],
        'medicationNotes': !(0, runtime_1.exists)(json, 'medication_notes') ? undefined : json['medication_notes'],
        'currentMedications': !(0, runtime_1.exists)(json, 'current_medications') ? undefined : json['current_medications'],
        'medicationsUnderConsideration': !(0, runtime_1.exists)(json, 'medications_under_consideration') ? undefined : json['medications_under_consideration'],
        'youscriptPatientId': !(0, runtime_1.exists)(json, 'youscript_patient_id') ? undefined : json['youscript_patient_id'],
    };
}
exports.RequisitionPgxReasonForTestingResponseFromJSONTyped = RequisitionPgxReasonForTestingResponseFromJSONTyped;
function RequisitionPgxReasonForTestingResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'medications_under_evaluation': value.medicationsUnderEvaluation,
        'complete_medication_list': value.completeMedicationList,
        'medical_records': value.medicalRecords,
        'is_kidney_or_liver_problem': value.isKidneyOrLiverProblem,
        'kidney_or_liver_problem': value.kidneyOrLiverProblem,
        'other_kidney_or_liver_problem': value.otherKidneyOrLiverProblem,
        'primary_reason': value.primaryReason,
        'recent_blood_transfusion': value.recentBloodTransfusion,
        'medication_notes': value.medicationNotes,
        'current_medications': value.currentMedications,
        'medications_under_consideration': value.medicationsUnderConsideration,
        'youscript_patient_id': value.youscriptPatientId,
    };
}
exports.RequisitionPgxReasonForTestingResponseToJSON = RequisitionPgxReasonForTestingResponseToJSON;
